import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';

const LessonsItem = ({ intl, item }) => {
  const {
    correct_count,
    incorrect_count,
    questions_count,
    retries_count,
    retries_max,
    id,
    type,
    training_id,
    title,
    description,
    status,
    passing_mandatory
  } = item;
  let completedPercent = 0;
  let passingPercent = 0;
  if (questions_count) {
    completedPercent = Math.round(((correct_count + incorrect_count) / questions_count) * 100);
    if (type !== 'Poll') {
      passingPercent = Math.round((correct_count / questions_count) * 100);
    }
  } else {
    completedPercent = 100;
    passingPercent = 100;
  }
  const isLesson = id !== 'start' && id !== 'finish';
  const tileLink = isLesson
    ? status !== 'upcoming' &&
      `/trainings/mytrainings/${training_id}/lessons/${id}`
    : `/trainings/mytrainings/${training_id}/${id}`;

  return (
    <Link
      to={tileLink}
      className={`tile_link ${status}`}
      onClick={e => status === 'upcoming' && e.preventDefault()}
    >
      {title && (
        <p className="title">
          <FormattedMessage id={title} />
        </p>
      )}
      {!isLesson && (
        <p>
          {status === 'completed'
            ? intl.formatMessage({ id: 'lessons_lesson_confirmed' })
            : intl.formatMessage({ id: description }) || ''}
        </p>
      )}
      {isLesson && (
        <p>
          <FormattedMessage id={`lessons_lesson_status_${status}`} />
        </p>
      )}
      {isLesson && completedPercent === 100 && type !== 'Poll' && (
        <p>
          <FormattedMessage
            id="lessons_lesson_passing"
            values={{ passingPercent }}
          />
        </p>
      )}
      {isLesson && (
        <p>
          <FormattedMessage
            id="lessons_lesson_completed"
            values={{ completedPercent }}
          />
        </p>
      )}
      {isLesson && type !== 'Poll' && questions_count && !passing_mandatory ? (
        <p>
          <FormattedMessage
            id="lessons_lesson_retries"
            values={{ retries_count, retries_max }}
          />
        </p>
      ) : (
        ''
      )}
    </Link>
  );
};

LessonsItem.propTypes = {
  intl: PropTypes.objectOf(PropTypes.any),
  item: PropTypes.objectOf(PropTypes.any),
};

export default injectIntl(LessonsItem);



// WEBPACK FOOTER //
// ./src/views/_Lessons/_lesson.js